{
  "collapse": "折叠",
  "expand": "扩展"
}
